import { JSX } from 'react/jsx-runtime';
import { WebPaymentMethod } from '../iap.types';
import { paymentMethodsButtonIcons } from './Config';

/**
 * Payment method button.
 * @param
 * @returns
 */
export function PaymentMethodBigButton({
  paymentMethod,
  onClick,
}: {
  paymentMethod: WebPaymentMethod;
  onClick: JSX.MouseEventHandler<HTMLDivElement>;
}) {
  /**
   * Render payment method button.
   */
  return (
    <div
      class="paymentMethod"
      id="paymentMethodTemplate"
      onClick={onClick}
      style="flex-basis:100%; background:none;padding: 0;"
    >
      <div
        class="paymentMethod"
        id="paymentMethodTemplate"
        style="width: 19rem;background: #FFF6E0;"
      >
        <div class="paymentMethodLogo" id="paymentMethodLogo">
          {paymentMethodsButtonIcons[paymentMethod]}
        </div>
      </div>
    </div>
  );
}
